import * as React from 'react';

import {Button} from 'shells/button/button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {Dialog} from 'shells/dialog/dialog';

type Props = {
    numSubscribedMemberships: number;
    onConfirmUnsubscribeAll: () => any;
    contactName: string;
};

export function UnsubscribeFromAllAudiencesButton(props: Props) {
    const [showUnsubscribeAllConfirmation, setShowUnsubscribeAllConfirmation] =
        React.useState<boolean>(false);
    const unsubscribeAllButtonRef = React.useRef();

    return (
        <>
            <ButtonMover direction='left' size='normal'>
                <Button
                    variant='text-primary'
                    onClick={() => {
                        setShowUnsubscribeAllConfirmation(true);
                    }}
                    getButtonRef={unsubscribeAllButtonRef}
                >
                    {props.numSubscribedMemberships
                        ? 'Unsubscribe from all audiences'
                        : 'Unsubscribe from all future outreach'}
                </Button>
            </ButtonMover>
            {showUnsubscribeAllConfirmation ? (
                <Dialog
                    question={`Are you sure you want to unsubscribe ${props.contactName} from all email outreach? You will never be able to resubscribe them to any audiences.`}
                    primaryText='Yes, unsubscribe from all outreach'
                    secondaryText='No, don’t do this'
                    isWarning={true}
                    anchor={unsubscribeAllButtonRef.current}
                    location='top-left'
                    onSecondary={() => {
                        setShowUnsubscribeAllConfirmation(false);
                    }}
                    onPrimary={() => props.onConfirmUnsubscribeAll()}
                    customStyles={{width: '372px', maxWidth: 'unset'}}
                />
            ) : undefined}
        </>
    );
}
